export const GET_VENDOR_VISIT_REQUEST = 'GET_VENDOR_VISIT_REQUEST';
export const GET_VENDOR_VISIT_SUCCESS = 'GET_VENDOR_VISIT_SUCCESS';
export const GET_VENDOR_VISIT_FAILURE = 'GET_VENDOR_VISIT_FAILURE';

export const GET_VENDOR_VISIT_LOCATION_REQUEST = 'GET_VENDOR_VISIT_LOCATION_REQUEST';
export const GET_VENDOR_VISIT_LOCATION_SUCCESS = 'GET_VENDOR_VISIT_LOCATION_SUCCESS';
export const GET_VENDOR_VISIT_LOCATION_FAILURE = 'GET_VENDOR_VISIT_LOCATION_FAILURE';
